<template>
  <div>
    <div class="eva_box">
      <div class="head">
        <p>{{ content.guide_words }}</p>
        <div class="stars evaList" v-if="evaWay === 'star'">
          <li
            @click="changeClickPosition(item.grade)"
            v-for="item in content.comment_config"
            :key="item.grade"
          >
            <img
              :src="item.selectImgUrl"
              v-if="grade <= item.grade && grade != 0"
              alt=""
            />
            <img
              :src="item.unselectImgUrl"
              v-if="grade > item.grade || grade == 0"
              alt=""
            />
          </li>
        </div>
        <div class="exp evaList" v-if="evaWay === 'exp'">
          <li
            @click="changeClickPosition(item.grade)"
            v-for="item in content.comment_config"
            :key="item.grade"
          >
            <img :src="item.selectImgUrl" v-if="grade == item.grade" alt="" />
            <img :src="item.unselectImgUrl" v-if="grade != item.grade" alt="" />
          </li>
        </div>
      </div>
      <div class="text evaList" v-if="evaWay === 'text'">
        <div
          :class="
            'textEvaItem' + (grade == item.grade ? ' textItemOnClick' : '')
          "
          v-for="item in content.comment_config"
          :key="item.grade"
          @click="changeClickPosition(item.grade)"
        >
          {{ item.content }}
        </div>
        <div
          class="textEvaItem textEvaItemEmpty"
          v-if="
            content.comment_config &&
              content.comment_config.length > 3 &&
              content.comment_config.length % 3 === 1
          "
        ></div>
        <div
          class="textEvaItem textEvaItemEmpty"
          v-if="
            content.comment_config &&
              content.comment_config.length > 3 &&
              content.comment_config.length % 3 > 0
          "
        ></div>
      </div>
      <div class="evaItems" v-if="grade != 0">
        <div>
          <p v-if="evaWay != 'text'">{{ showText }}</p>
        </div>
        <el-radio-group
          v-model="grade_detail"
          size="large"
          class="items"
          v-if="child.length > 0"
          :disabled="grade === 0 || rateDisabled || endEvaluate"
        >
          <el-radio
            class="item"
            v-for="(cItem, cIndex) in child"
            :key="cIndex"
            :label="cItem"
          >
            {{ cItem }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="bottom">
        <el-button
          class="btn_submit"
          :disabled="grade === 0 || rateDisabled || endEvaluate"
          @click="handleSubmit"
          v-if="!endEvaluate"
        >
          {{ btnTitle }}
        </el-button>
        <p v-if="endEvaluate">感谢您对本次服务的评价！</p>
      </div>
    </div>
  </div>
</template>

<script>
import apiHttp from "@/api/api";
import "@/assets/icon/iconfont.css";
const GRADE = {
  VERY_SATISFIED: 1, // 非常满意
  SATISFIED: 2, // 满意
  UNSATISFIED: 3, // 一般（不满意）
  UNSATISFIED_SERVICE: 4, // 服务不满意
  UNSATISFIED_OTHER: 5, // 其他不满意
  SATISFIED_NEW: 6, // 满意新版
  UNSATISFIED_NEW: 7, // 不满意新版
};

const EVALUATION_WAY = {
  STAR: 2, // 星星评价
  EXP: 3, // 笑脸评价
  TEXT: 1, // 文字评价
};

export default {
  name: "messageRate",
  data() {
    return {
      accessType: "mobile", //pc端 移动端
      btnTitle: "提交",
      endEvaluate: false,
      evaWay: "text",
      content: {},
      grade_detail: "",
      grade: 0,
    };
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async handleSubmit() {
      if (this.child.length > 0 && !this.grade_detail) {
        this.$message({
          showClose: true,
          message: "请选择二级分类",
          type: "warning",
        });
        return;
      }
      let params = {
        sessionId: Number(this.message.sessionId),
        grade: this.grade, // 1-非常满意 2-满意 3-一般（不满意） 4-服务不满意 5-其他不满意 6-满意新版 7-不满意新版
        grade_detail: this.grade_detail,
      };
      const res = await apiHttp.saveEvaluateMsg(params);
      if (res.ret === 200) {
        this.endEvaluate = true;
        this.btnTitle = "已提交";
        localStorage.setItem(
          this.message.sessionId.toString(),
          JSON.stringify(params)
        );
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "warning",
        });
      }
    },
    // 改变满意评级
    changeClickPosition(grade) {
      if (this.endEvaluate || this.rateDisabled) {
        return;
      } else {
        this.grade = grade;
        this.grade_detail = "";
      }
    },

    // 历史评价消息回显
    handleHistoryRateMessageDisplay() {
      const record = localStorage.getItem(this.message.sessionId.toString());
      if (record) {
        const recordObj = JSON.parse(record);
        // 处理历史数据的回显，兼容老数据的展示，满意度-新版（grade=6）当作非常满意
        if ([GRADE.VERY_SATISFIED].includes(recordObj.grade)) {
          this.grade = GRADE.VERY_SATISFIED;
        } else if (
          [GRADE.SATISFIED, GRADE.SATISFIED_NEW].includes(recordObj.grade)
        ) {
          this.grade = GRADE.SATISFIED;
        } else {
          this.grade = GRADE.UNSATISFIED_NEW;
        }
        this.grade_detail = recordObj.grade_detail || "";
      }
    },
  },
  computed: {
    rateDisabled() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.btnTitle =
        this.message.grade != "0"
          ? "已评价"
          : this.message.satisfaction_is_expired == "1"
          ? "已过期"
          : "提交";
      return (
        this.message.grade != "0" || this.message.satisfaction_is_expired == "1"
      );
    },
    showText() {
      let item = this.content.comment_config.find(
        (item) => item.grade == this.grade
      );
      if (item) {
        return item.content || "";
      }
      return "";
    },
    child() {
      let item = this.content.comment_config.find(
        (item) => item.grade == this.grade
      );
      if (item) {
        return item.child || "";
      }
      return [];
    },
  },
  created() {
    try {
      this.content = JSON.parse(this.message.content);
      // 满意度位置  客户越满意（grade越小）显示的位置越靠右
      if (this.content && this.content.comment_config) {
        this.message.evaluation_way == EVALUATION_WAY.STAR
          ? this.content.comment_config.sort((a, b) => b.grade - a.grade)
          : this.content.comment_config.sort((a, b) => a.grade - b.grade);
      }
      // 默认选中最高的满意度
      if (
        this.message.grade == 0 &&
        this.message.satisfaction_is_expired != 1 &&
        this.content.comment_config
      ) {
        const defaultGradeIndex =
          this.message.evaluation_way == EVALUATION_WAY.STAR
            ? this.content.comment_config.length - 1
            : 0;
        this.grade = this.content.comment_config[defaultGradeIndex].grade;
      } else {
        this.grade = this.message.grade;
      }
    } catch (err) {
      this.content = this.message.content;
      if (this.content && this.content.comment_config) {
        this.message.evaluation_way == EVALUATION_WAY.STAR
          ? this.content.comment_config.sort((a, b) => b.grade - a.grade)
          : this.content.comment_config.sort((a, b) => a.grade - b.grade);
      }
      if (
        this.message.grade == 0 &&
        this.message.satisfaction_is_expired != 1 &&
        this.content.comment_config
      ) {
        const defaultGradeIndex =
          this.message.evaluation_way == EVALUATION_WAY.STAR
            ? this.content.comment_config.length - 1
            : 0;
        this.grade = this.content.comment_config[defaultGradeIndex].grade;
      } else {
        this.grade = this.message.grade;
      }
    }
    switch (this.message.evaluation_way) {
      case EVALUATION_WAY.TEXT:
        this.evaWay = "text";
        break;
      case EVALUATION_WAY.STAR:
        this.evaWay = "star";
        break;
      case EVALUATION_WAY.EXP:
        this.evaWay = "exp";
        break;
      default:
        break;
    }
  },
  mounted() {
    this.handleHistoryRateMessageDisplay();
  },
};
</script>
<style lang="stylus">
.el-radio__label {
  padding-left: 0;
}
.el-radio__input {
  display: none;
}
.el-checkbox {
    margin-right: 0;
}
.eva_box {
    width: 327px;
    /* height: 274px; */
    background: #FFFFFF;
    border-radius: 8px;
    margin: 0 auto;
    margin-bottom: 14px;
    max-width: 100%;
  }

  .bottom {
    border-radius: 8px;
  }

  .head {
    background-image: linear-gradient(0deg, rgba(0,172,235,0) 14%, rgba(0,172,235,0.16) 100%);
    border-radius: 4px 4px 0px 0px;
    padding-top: 28px;
  }

  .eva_box p {
    width: 268px;
    height: 20px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333;
    text-align: center;
    font-weight: 500;
    margin: 0 auto;
  }

  .eva_box ul {
    width: auto;
    list-style: none;
    display: flex;
  }

  .eva_box img {
    width: 24px;
    height: 24px;
  }

  .eva_box li {
    margin-right: 24px;
    list-style: none;
  }

  .eva_box li:last-child {
    margin-right: 0;
  }

  .evaList {
    width: 216px;
    height: 24px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }

  .eva_box .bottom {
    width: 100%;
    height: auto;
    background-color: #fff;
    display: flex;
  }

  .eva_box .bottom .btn_submit {
    width: 250px;
    height: 28px;
    line-height: 9px;
    background: #00ACEB;
    border-radius: 4px;
    border: none;
    color: white;
    font-size: 12px;
    font-weight: 400;
    margin: 24px auto;
    margin-top: 24px;
  }

  .el-button.is-disabled {
    background: #DEDEDE !important;
  }

  .eva_box .evaItems p {
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #555555;
    letter-spacing: 0;
    font-weight: 500;
    margin-top: 16px;
  }

  .evaItems .item {
    width: 118px;
    height: 26px;
    border: 1px solid rgba(222, 222, 222, 1);
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    padding-left: -3px;
  }

  .evaItems .item:nth-last-child(-n+2) {
    margin-bottom: 0;
  }
  .evaItems .item:nth-child(2n) {
    margin-right : 0;
  }


  .evaItems {
    width: 250px;
    margin: 0 auto;
  }

  .evaItems .item:nth-child(odd) {
    margin-right: 10px;
  }

  .evaItems .items {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
  }

  .bottom p {
    margin: 20px auto;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
  }

  .textEvaItem {
    width: 88px;
    height: 28px;
    border: 1px solid rgba(222, 222, 222, 1);
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .textEvaItemEmpty{
    border: none;
  }

  .textEvaItem:nth-child(3),
  .textEvaItem:last-child {
    margin-right: 0;
  }

  .text.evaList {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    height: auto;
    width: 100%;
  }

  .textItemOnClick {
    background: #00ACEB;
    color: #FFFFFF;
    border: none
  }

  .item .el-checkbox__input {
    display: none;
  }

  .el-checkbox__label {
    padding-left: 0;
    font-size: 12px;
  }

  .item.is-checked {
    color: #00ACEB;
    background: rgba(0, 172, 235, 0.10);
    border: 1px solid rgba(0, 172, 235, 1);
  }
</style>
